var app = angular.module('tf.introCourse', [])
    .controller('gameWelcomeWizardCtrl', ["$scope", "$state", "$http", "$timeout", "$uibModal", "$localStorage", "chainService", "$uibModalStack", "$q", gameWelcomeWizardController]);

/** @ngInject */
function gameWelcomeWizardController($scope, $state, $http, $timeout, $uibModal, $localStorage, chainService, $uibModalStack, $q) {

    $scope.wizardState = 1;

    $scope.state = {
        wizard: null,
        underlyingCode: 'CBA',
        company: null
    };

    $scope.selectStock = function(stock) {
        $scope.state.underlyingCode = stock.underlying;
        $scope.state.company = stock;
        $scope.nextStep($scope.wizardState);
    };

    $scope.previousStep = function (wizardState) {
        $scope.wizardState = wizardState - 1;
        return wizardState;
    };

    $scope.nextStep = function (wizardState) {
        $scope.wizardState = wizardState + 1;

        if ($scope.state.wizard === 'beginner') {
            onNextBeginner($scope.wizardState, $scope.state);
        }

        else if ($scope.state.wizard === 'builder') {
            onNextBuilderWizard($scope.wizardState, $scope.state);
        }

        return [$scope.wizardState, $scope.state];
    };

    var onNextBeginner = function (wizardState, status) {
        if (wizardState === 14) {
            if ($scope.stock.ivRank < 0.5) {
                $scope.strategyFilter.volatility = 'increasing';
            } else {
                $scope.strategyFilter.volatility = 'falling';
            }

            // TODO move this out to a before page load for step 12
            function filterStrategies(element, index, array) {

                if ($scope.strategyFilter.price === 'bullish') {
                    return element.shortName === 'long_call';
                } else if ($scope.strategyFilter.price === 'bearish') {
                    return element.shortName === 'short_call';
                } else {
                    return false;
                }
            }

            $http.get('app/apps/optionsCookbook/strategies.json')
                .then(function (response) {
                    $scope.strategies = response.data.filter(filterStrategies);
                }).catch(function (err) {
                // log error
            });

        } else if (wizardState === 8) {
            if (status.direction === 'up') {
                $scope.strategyFilter = {
                    price: 'bullish',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            } else if (status.direction === 'down') {
                $scope.strategyFilter = {
                    price: 'bearish',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            } else if (status.direction === 'nowhere') {
                $scope.strategyFilter = {
                    price: 'neutral' || 'uncertain',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            }
        } else if (wizardState === 7) {

            $scope.loadChartData();
        }
    }

    var onNextBuilderWizard = function (wizardState, status) {

            if (wizardState === 11) {
                if ($scope.stock.ivRank < 0.5) {
                    $scope.strategyFilter.volatility = 'increasing';
                } else {
                    $scope.strategyFilter.volatility = 'falling';
                }

                // TODO move this out to a before page load for step 12
                function filterStrategies(element, index, array) {
                    if ($scope.strategyFilter.price === 'bullish') {
                        return element.shortName === 'long_call';
                    } else if ($scope.strategyFilter.price === 'bearish') {
                        return element.shortName === 'short_call';
                    } else {
                        return false;
                    }
                }

                $http.get('app/apps/optionsCookbook/strategies.json')
                    .then(function (response) {
                        $scope.strategies = response.data.filter(filterStrategies);
                    }).catch(function (err) {
                    // log error
                });

        } else if (wizardState === 4) {

            $scope.loadChartData();
        } else if (wizardState === 5) {
            if (status.direction === 'up') {
                $scope.strategyFilter = {
                    price: 'bullish',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            } else if (status.direction === 'down') {
                $scope.strategyFilter = {
                    price: 'bearish',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            } else if (status.direction === 'nowhere') {
                $scope.strategyFilter = {
                    price: 'neutral' || 'uncertain',
                    volatility: null,
                    time: null,
                    level: 1 || 3,
                    noMargin: false,
                    text: ''
                };
            }
        }
    };


    function getNextExpiry() {
        return chainService($scope.state.underlyingCode).then(function (chain) {
            var expiries = [];
            chain.series.filter(function (s) {
                return moment().startOf('month').add(3, 'months').isBefore(moment(s.expiry));
            }).forEach(function (s) {
                expiries.push({
                    expiry: s.expiry,
                    expiryType: s.expiryType
                });
            });

            if (expiries.length === 0) {
                var lastSeries = chain.series[chain.series.length - 1];

                expiries.push({
                        expiry: lastSeries.expiry,
                        expiryType: lastSeries.expiryType
                    });
            }
            return expiries;
        });
    }

    function getRecipeParameters(strategy) {
        return getNextExpiry().then(function (expiries) {
            return {
                name: strategy.userInitial,
                longName: strategy.fullName,
                expiryDate: expiries[0].expiry,
                code: $scope.stock.underlying,
                style: strategy.style,
                legs: strategy.legs.map(function (leg) {
                    return {
                        optionType: leg.optionType,
                        priceWeight: leg.priceWeight,
                        size: leg.size,
                        timeOffset: leg.timeOffset || 0
                    };
                })
            };
        });
    }

    var createStrategy = function (strategy) {
        getRecipeParameters(strategy).then(function (recipeParams) {
            $http.post('/tradefloor/api/strategy/kitchen', recipeParams).then(function (response) {
                var strategyLegs = response.data;

                var newStrategy = {
                    underlying: recipeParams.code,
                    name: recipeParams.code + ' ' + recipeParams.longName,
                    description: '',
                    gcd: 1,
                    scaleFactor: 1,
                    trades: strategyLegs,
                    type: recipeParams.name,
                    tmc: true
                };

                $http.put('/tradefloor/api/strategy', newStrategy).then(function (response) {
                    var strategy = response.data;
                    $localStorage['active_strategy'] = strategy.id;
                    $localStorage.$apply();
                    $uibModalStack.dismissAll();
                    $state.go("strategy", { fromIntro: true });
                });
            });
        });
    };

    $scope.createStrategy = createStrategy;

    $scope.strategyDetail = function (strategy) {
        var modalInstance = $uibModal.open({
            templateUrl: "app/game/partials/introCourse/templates/strategyDetail.tpl.html",
            size: "lg",
            controller: ['$scope', function ($scope) {
                $scope.strategy = strategy;
                $scope.createStrategy = createStrategy;
            }]
        });
        modalInstance.result.then().catch();
    };



    $scope.priceDates = [];
    $scope.volDates = [];

    $scope.state.underlyingCode = 'CBA';

    $scope.chart = {
        range: '1y'
    };

    $scope.optionsPrice = {
        chart: {
            type: 'candlestickBarChart',
            height: 230,
            margin: {
                top: 20,
                right: 20,
                bottom: 20,
                left: 60
            },
            x: function (d) {
                return d['date'];
            },
            y: function (d) {
                return d['close'];
            },
            duration: 100,
            forceX: [moment().add(90, 'days').toDate()],
            xAxis: {
                axisLabel: 'Dates',
                tickFormat: function (d) {
                    return d3.time.format('%d/%m/%y')(new Date(d));
                },
                showMaxMin: false
            },

            yAxis: {
                axisLabel: 'Stock Price',
                tickFormat: function (d) {
                    return '$' + d3.format(',.3f')(d);
                },
                showMaxMin: false
            }
        }
    };

    $scope.optionsPricePoints = {
        chart: {
            type: 'candlestickBarChart',
            height: 330,
            margin: {
                top: 20,
                right: 20,
                bottom: 20,
                left: 60
            },
            x: function (d) {
                return d['date'];
            },
            y: function (d) {
                return d['close'];
            },
            duration: 100,

            xAxis: {
                axisLabel: 'Dates',
                tickFormat: function (d) {
                    return d3.time.format('%d/%m/%y')(new Date(d));
                },
                showMaxMin: false
            },

            yAxis: {
                axisLabel: 'Index',
                tickFormat: function (d) {
                    return d3.format(',.1f')(d);
                },
                showMaxMin: false
            }
        }
    };

    $scope.optionsVolatility = {
        chart: {
            type: 'lineChart',
            height: 200,
            margin : {
                top: 20,
                right: 20,
                bottom: 20,
                left: 60
            },
            showLegend: false,
            x: function(d){ return d['date']; },
            y: function(d){ return d['IV30']; },
            duration: 100,

            xAxis: {
                axisLabel: 'Dates',
                tickFormat: function(d) {
                    return d3.time.format('%d/%m/%y')(new Date($scope.volDates[d]));
                },
                showMaxMin: false
            },

            yAxis: {
                axisLabel: 'IV 30',
                tickFormat: function(d){
                    return d3.format(',.3f')(d);
                },
                showMaxMin: false
            }
        }
    };

    $http.get('/tradefloor/api/stockscreener?underlying=' + $scope.state.underlyingCode).then(function (response) {
        response.data.forEach(function (s) {
            $scope.stockData = s;
        });
    });

    $scope.loadChartData = function () {

        $http.get('/tradefloor/api/stockscreener?underlying=' + $scope.state.underlyingCode).then(function (response) {
            response.data.forEach(function (s) {
                if (s.underlying === $scope.state.underlyingCode) {
                    $scope.stock = s;
                }
            });
        });

        return $http.get('/tradefloor/api/prices/chart/' + $scope.state.underlyingCode + '?r=' + $scope.chart.range).then(function (response) {
            Papa.parse(response.data, {
                download: false,
                complete: function (results) {
                    $scope.priceDates = [];
                    $scope.volDates = [];
                    results.data.shift(); // Remove header

                    $scope.chartPriceData = [{
                        values: results.data.filter(function (row) {
                            return row[0];
                        })
                            .map(function (row) {
                                $scope.priceDates.push(new Date(row[0]));
                                return {
                                    date: new Date(row[0]),
                                    open: parseFloat(row[1]),
                                    high: parseFloat(row[2]),
                                    low: parseFloat(row[3]),
                                    close: parseFloat(row[4])
                                }
                            })
                    }];


                    var iVolDate = 0;
                    $scope.chartVolatilityData = [{
                        key : 'Volatility',
                        values: results.data.filter(function (row) {
                            return row[0];
                        })
                            .map(function (row) {
                                $scope.volDates.push(new Date(row[0]));
                                return {
                                    date: iVolDate++,
                                    IV30 : parseFloat(row[5]) * 100.0
                                };
                            })}];
                }
            });
        });
    };

    //stock screener code

    $http.get('/tradefloor/api/stockscreener').
    then(function(response) {
        $scope.stocks = response.data;

        $scope.stocks.forEach(function(s) {
            s.chartType = 'optionsPrice';
            s.chartRange = '30d';
            s.absPriceChangePercent = -Math.abs(s.priceChangePercent);
            s.negPriceChangePercent = -s.priceChangePercent;
        })
    });

    $scope.order = 'absPriceChangePercent';
    $scope.reverse = false;
    $scope.nameFilter = '';

    $scope.stockFilter = function(stock) {
        return stock.underlying.toUpperCase().indexOf($scope.nameFilter.toUpperCase()) > -1 ||
            stock.name.toUpperCase().indexOf($scope.nameFilter.toUpperCase()) > -1;
    };

    $scope.$watch("order",

        function (newVal) {
            $timeout(function () {
                $("[masonry]").masonry('reloadItems');
                $("[masonry]").masonry();
            })
        })
    $scope.$watch("reverse",

        function (newVal) {
            $timeout(function () {
                $("[masonry]").masonry('reloadItems');
                $("[masonry]").masonry();
            })
        })


    $scope.changeSortOrder = function(sortOrder) {
        if ($scope.order === sortOrder) {
            $scope.reverse = !$scope.reverse
        } else {
            $scope.order = sortOrder;
            $scope.reverse = false;
        }
    };

    //stock screener code

    var priceChartApi;

    $scope.priceChartReady = function ($scope, $elem) {
        priceChartApi = $scope.api;
        resize();
    };

    function resize() {
        if (priceChartApi !== null) {
            $timeout(function () {
                priceChartApi.refresh();
            });
        }
    }

}
